/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";

/**
 * OTEL attribute value - any of the OTLP/JSON value kinds
 */
export type OTELAttributeValue = {
  /**
   * Array value (passed through)
   */
  arrayValue?: any | undefined;
  /**
   * Boolean value
   */
  boolValue?: boolean | undefined;
  /**
   * Bytes value (base64-encoded per OTLP/JSON)
   */
  bytesValue?: string | undefined;
  /**
   * Double value
   */
  doubleValue?: number | undefined;
  /**
   * Integer value (string-encoded per OTLP/JSON, or raw number)
   */
  intValue?: any | undefined;
  /**
   * Key-value list value (passed through)
   */
  kvlistValue?: any | undefined;
  /**
   * String value
   */
  stringValue?: string | undefined;
};

/** @internal */
export type OTELAttributeValue$Outbound = {
  arrayValue?: any | undefined;
  boolValue?: boolean | undefined;
  bytesValue?: string | undefined;
  doubleValue?: number | undefined;
  intValue?: any | undefined;
  kvlistValue?: any | undefined;
  stringValue?: string | undefined;
};

/** @internal */
export const OTELAttributeValue$outboundSchema: z.ZodMiniType<
  OTELAttributeValue$Outbound,
  OTELAttributeValue
> = z.object({
  arrayValue: z.optional(z.any()),
  boolValue: z.optional(z.boolean()),
  bytesValue: z.optional(z.string()),
  doubleValue: z.optional(z.number()),
  intValue: z.optional(z.any()),
  kvlistValue: z.optional(z.any()),
  stringValue: z.optional(z.string()),
});

export function otelAttributeValueToJSON(
  otelAttributeValue: OTELAttributeValue,
): string {
  return JSON.stringify(
    OTELAttributeValue$outboundSchema.parse(otelAttributeValue),
  );
}
